import Cookies from 'universal-cookie';

const isVeriiproDomain = () => {
  const host = process.env.REACT_APP_ALLOWED_HOST || '';
  return host.endsWith('.veriipro.com');
};

// Demo and prod are sibling subdomains of the shared apex .veriipro.com, so a
// cookie set with domain:'.veriipro.com' is a single cookie across both envs.
// We partition the auth cookie NAMES by environment so the two never collide,
// while keeping the shared domain for intra-env (candidate/employer/public) sharing.
const resolveEnv = () => {
  const explicit = (process.env.REACT_APP_ENV || '').trim().toLowerCase();
  if (explicit) return explicit;
  const host = (process.env.REACT_APP_ALLOWED_HOST || '').toLowerCase();
  if (!host.endsWith('.veriipro.com')) return 'development';
  if (host.startsWith('demo')) return 'demo';
  if (host.startsWith('temp')) return 'stage';
  return 'production';
};

const ENV = resolveEnv();

export const cookieName = (baseName) => (ENV === 'production' ? baseName : `${ENV}__${baseName}`);

export const TOKEN_COOKIE = cookieName('veriipro-token');
export const USER_COOKIE = cookieName('veriipro-user');
export const DEVICE_ID_COOKIE = cookieName('deviceId');

export const setCookie = (name, value, expiry = 1) => {
  const cookies = new Cookies();
  cookies.set(name, value, { path: '/' });
};

export const setCookieForCrossOrigin = (name, value) => {
  try {
    const cookies = new Cookies();
    cookies.set(name, value, {
      path: '/',
      ...(isVeriiproDomain() && { domain: '.veriipro.com' }),
      maxAge: 60 * 60 * 24 // 24 hours
    });
  } catch (error) {
    console.error('setCookieForCrossOrigin error:', error.message);
  }
};

export const getCookie = (name) => {
  const cookies = new Cookies();
  return cookies.get(name);
};

export const removeCookie = (name) => {
  const cookies = new Cookies();
  cookies.remove(name, { path: '/' });
};

export const removeCookieForCrossOrigin = (name) => {
  try {
    const cookies = new Cookies();
    cookies.remove(name, {
      path: '/',
      ...(isVeriiproDomain() && { domain: '.veriipro.com' })
    });
  } catch (error) {
    console.error('removeCookieForCrossOrigin error:', error.message);
  }
};

export const removeAllCookie = () => {
  const cookies = new Cookies();
  cookies.remove();
};

// VTS-593: one-time migration sweep. Before this fix the auth cookies were
// written with the BARE names on the shared .veriipro.com apex, so a browser
// that logged in pre-fix still carries orphaned bare cookies alongside the new
// env-scoped ones. On non-production envs those bare cookies are never read
// again and linger ~24h; clear them so the migration is clean. STRICT NO-OP on
// production, where the bare name IS the active cookie (removing it would wipe
// the live prod session).
export const clearLegacyBareCookies = () => {
  if (ENV === 'production') return;
  try {
    removeCookieForCrossOrigin('veriipro-token');
    removeCookieForCrossOrigin('veriipro-user');
    removeCookieForCrossOrigin('deviceId');
  } catch (error) {
    console.error('clearLegacyBareCookies error:', error.message);
  }
};
